import cssVars from 'css-vars-ponyfill';
import tinycolor from 'tinycolor2';

import { AUTHENTICATED_USER_ACCESS } from 'constants/scopes';
import { USER, VIDEO } from 'constants/ssr';
import { getCloudfrontURI } from 'utilities/avatar';

export function getPlayIconContrastedColor(color) {
  if (color) {
    const colorLuminance = tinycolor(color).getLuminance();

    return colorLuminance > 0.2 ? 'black' : 'white';
  }
}

export function getCustomBrandLogo() {
  const path = window[VIDEO]?.customBranding?.brandLogoPath;

  if (path) {
    return getCloudfrontURI(path);
  }
}

export function getLoomBrandVisibility() {
  const user = window[USER];
  const customBranding = window[VIDEO]?.customBranding;

  // NOTE: this relies on user being injected in window. should prefer to use the hook for scope here.
  if (user && user.scopes.includes(AUTHENTICATED_USER_ACCESS)) {
    return false;
  }

  if (customBranding) {
    return customBranding.brandShowBranding;
  }

  return true;
}

export const injectCustomBrandColors = () => {
  const color = window[VIDEO]?.customBranding?.brandPrimaryColor;

  if (color) {
    cssVars({
      variables: {
        '--brandThemedPlayProgressBarColor': color,
        '--brandThemedBigPlayButtonColor': color,
        '--brandThemedBigPlayButtonIconColor':
          getPlayIconContrastedColor(color),
        '--brandThemedLinkColor': 'var(--lns-color-body)',
        '--brandThemedLinkDecoration': 'underline',
        '--brandThemedLinkDecorationColor': 'var(--lns-color-grey4)',
        '--brandThemedLinkUnderlinePosition': 'under',
        '--brandThemedPrimaryButtonBackgroundColor': 'var(--lns-color-body)',
      },
    });
  }
};
